import React from 'react';
import Forecasting from '../../elements/Body/Forecasting/Forecasting';
class ForecastingPage extends React.Component {
  render() {
    return (
      <Forecasting />
    );
  }
}
export default ForecastingPage;
